document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-randomize-products="true"]').forEach((grid) => {
    const cards = Array.from(grid.children);
    if (cards.length < 2) return;

    for (let index = cards.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(Math.random() * (index + 1));
      [cards[index], cards[swapIndex]] = [cards[swapIndex], cards[index]];
    }

    cards.forEach((card) => {
      grid.appendChild(card);
    });
  });
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!form.matches('[data-cart-form]')) return;

  const button = form.querySelector('[type="submit"]');
  if (!button) return;

  button.setAttribute('aria-busy', 'true');
  button.textContent = 'Adding...';
});
